import { render } from "./CoursePost.vue?vue&type=template&id=ae8495c0"
import script from "./CoursePost.vue?vue&type=script&lang=js"
export * from "./CoursePost.vue?vue&type=script&lang=js"

import exportComponent from "F:\\-=Projects=-\\Sites\\map\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__